<script setup>
import { ref, defineProps, onMounted} from 'vue'

// タブ内のコンポーネント
import TabFieldInfo from './TabFieldInfo.vue';
import TabFieldImage from './TabFieldImage.vue';
import TabFieldWeather from './TabFieldWeather.vue';
import TabFieldEvent from './TabFieldEvent.vue';
import TabFieldCamera from './TabFieldCamera.vue';
import TabFieldAIAnalysis from './TabFieldAIAnalysis.vue';

const props = defineProps(['field'])
const field = ref(props.field)

const images = ref(null)

const tabFieldEvent = ref();
const isExpanded = ref(false);

onMounted(() => {
  const tabEl = document.querySelector('#event-tab')
  tabEl.addEventListener('shown.bs.tab', () => {
    tabFieldEvent.value.reloadCalendar();
  })
  
  // offcanvas が閉じられたときに拡大状態をリセット
  const offcanvasEl = document.querySelector('#offcanvasRight');
  if (offcanvasEl) {
    offcanvasEl.addEventListener('hidden.bs.offcanvas', () => {
      isExpanded.value = false;
      offcanvasEl.classList.remove('offcanvas-fullwidth');
    });
  }
})

function toggleExpand() {
  isExpanded.value = !isExpanded.value;
  // 親要素（offcanvas）を取得
  const offcanvasEl = document.querySelector('#offcanvasRight');
  console.log('offcanvasEl:', offcanvasEl);
  console.log('isExpanded:', isExpanded.value);
  
  if (offcanvasEl) {
    if (isExpanded.value) {
      offcanvasEl.classList.add('offcanvas-fullwidth');
      console.log('Added offcanvas-fullwidth class');
    } else {
      offcanvasEl.classList.remove('offcanvas-fullwidth');
      console.log('Removed offcanvas-fullwidth class');
    }
    console.log('Classes:', offcanvasEl.classList);
  } else {
    console.error('offcanvasRight element not found');
  }
}
</script>

<template>
  <div class="offcanvas-header bg-dark text-light p-2 d-flex align-items-center">
    <img v-bind:src="field?.IconUrl" alt="Bootstrap" width="30" height="24" class="me-2">
    <h5 class="offcanvas-title flex-grow-1 mb-0" id="offcanvasRightLabel">{{ field?.Name }}</h5>
    <button type="button" class="btn btn-sm text-white p-1 me-2" @click="toggleExpand" :title="isExpanded ? '通常表示に戻す' : '全画面表示'">
      <i :class="isExpanded ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'"></i>
    </button>
    <button type="button" class="btn-close text-reset btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body p-0">
    <ul class="nav nav-fill nav-tabs" id="tabCanvas" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active px-0" id="info-tab" data-bs-toggle="tab" data-bs-target="#info-tab-pane" type="button" role="tab" aria-controls="info-tab-pane" aria-selected="true">
          <i class="bi bi-info-circle"></i> 基本情報
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link px-0" id="photo-tab" data-bs-toggle="tab" data-bs-target="#photo-tab-pane" type="button" role="tab" aria-controls="photo-tab-pane" aria-selected="false">
          <i class="bi bi-image"></i> 画像
          <span class="badge rounded-pill text-bg-warning">{{ images && images.length }}</span>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link px-0" id="ai-tab" data-bs-toggle="tab" data-bs-target="#ai-tab-pane" type="button" role="tab" aria-controls="ai-tab-pane" aria-selected="false">
          <i class="bi bi-robot"></i> AI分析
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link px-0" id="weather-tab" data-bs-toggle="tab" data-bs-target="#weather-tab-pane" type="button" role="tab" aria-controls="weather-tab-pane" aria-selected="false">
          <i class="bi bi-cloud-sun"></i> 気象情報
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link px-0" id="event-tab" data-bs-toggle="tab" data-bs-target="#event-tab-pane" type="button" role="tab" aria-controls="event-tab-pane" aria-selected="false">
          <i class="bi bi-calendar3"></i> イベント
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link px-0" id="cam-tab" data-bs-toggle="tab" data-bs-target="#cam-tab-pane" type="button" role="tab" aria-controls="cam-tab-pane" aria-selected="false">
          <i class="bi bi-camera-video"></i> Live
        </button>
      </li>
    </ul>

    <!-- タブ内のコンテンツ -->
    <div class="tab-content" id="tabContent">
      <!-- 基本情報タブ -->
      <div class="tab-pane fade show active" id="info-tab-pane" role="tabpanel" aria-labelledby="info-tab" tabindex="0">
        <TabFieldInfo :key="field" v-bind:field="field"></TabFieldInfo>
      </div>
      <!-- 画像タブ -->
      <div class="tab-pane fade" id="photo-tab-pane" role="tabpanel" aria-labelledby="photo-tab" tabindex="0">
        <TabFieldImage :key="field" v-bind:field="field"></TabFieldImage>
      </div>
      <!-- AI分析タブ -->
      <div class="tab-pane fade" id="ai-tab-pane" role="tabpanel" aria-labelledby="ai-tab" tabindex="0">
        <TabFieldAIAnalysis :key="field" v-bind:field="field"></TabFieldAIAnalysis>
      </div>
      <!-- 気象情報タブ -->
      <div class="tab-pane fade" id="weather-tab-pane" role="tabpanel" aria-labelledby="weather-tab" tabindex="0">
        <TabFieldWeather :key="field" v-bind:field="field"></TabFieldWeather>
      </div>
      <!-- イベントタブ -->
      <div class="tab-pane fade" id="event-tab-pane" role="tabpanel" aria-labelledby="event-tab" tabindex="0">
        <TabFieldEvent :key="field" v-bind:field="field" ref="tabFieldEvent"></TabFieldEvent>
      </div>
      <!-- カメラタブ -->
      <div class="tab-pane fade" id="cam-tab-pane" role="tabpanel" aria-labelledby="cam-tab" tabindex="0">
        <TabFieldCamera :key="field" v-bind:field="field"></TabFieldCamera>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-tabs{
  background-color: lavender;
}
</style>

<style>
#offcanvasRight.offcanvas-fullwidth,
.offcanvas.offcanvas-fullwidth {
  width: 100% !important;
  max-width: 100% !important;
}

/* トランジションをスムーズに */
.offcanvas.offcanvas-end {
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out !important;
}
</style>
